import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
// @ts-expect-error migrate upstream
import { connect as connectFlux } from 'general-store';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { useFetchDashboardOnOpen } from '../../../hooks/useFetchDashboardOnOpen';
// @ts-expect-error migrate upstream
import DashboardsDependency from '../../../dependencies/DashboardsDependency';
import compose from 'transmute/compose';
import { track as dashboardTracker, EVENTS, DashboardUITracker
// @ts-expect-error migrate upstream
} from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { withDashboardPermission } from '../../../decorators/withDashboardPermission';
// @ts-expect-error migrate upstream
import { withDialog } from 'reporting-action-components/dialog/DialogProvider';
import { DashboardFloatingAlertStore } from 'dashboard-components/js/shared/DashboardFloatingAlertStore.ts';
// @ts-expect-error migrate upstream
import { withUserInfo } from 'dashboard-components/context/user-info-context';
// @ts-expect-error migrate upstream
import { ShareToSlack, RecordType } from 'slack-ui-library';
import EmailDashboardButton from 'reporting-action-components/reportingActions/emailReport/EmailDashboardButton';
// @ts-expect-error migrate upstream
import ManageRecurringDashboardEmailsButton from 'reporting-action-components/reportingActions/manageRecurringEmails/ManageRecurringDashboardEmailsButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareActionsDropdown = ({
  dashboard,
  dashboards,
  currentDashboardId
}) => {
  const renderCopyUrl = () => /*#__PURE__*/_jsx(UICopyButton, {
    value: document.location,
    hint: "",
    hintSuccess: "",
    onClick: () => {
      dashboardTracker(EVENTS.clickCopyDashboardUrl);
      DashboardFloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.copyDashboardUrl.success.title'
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.copyDashboardUrl.success.message'
        }),
        type: 'success'
      });
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.action.copyDashboardUrl.name"
    })
  });
  const renderShareToSlackButton = () => /*#__PURE__*/_jsx(ShareToSlack, {
    description: {
      header: I18n.text('shareToSlack.dashboard.header'),
      body: I18n.text('shareToSlack.dashboard.body')
    },
    recordToShare: {
      id: currentDashboardId,
      type: RecordType.DASHBOARD
    },
    placeIdentifier: "DashboardUI-dashboard-action-dropdown"
  }, "share-to-slack");
  const renderSendEmail = () => /*#__PURE__*/_jsx(EmailDashboardButton, {
    dashboard: dashboard,
    appUsageTracker: DashboardUITracker,
    trackingProperties: {
      interactionSource: 'actions-dropdown'
    }
  });
  const renderManageEmail = () => /*#__PURE__*/_jsx(ManageRecurringDashboardEmailsButton, {
    dashboard: dashboard,
    appUsageTracker: DashboardUITracker,
    trackingProperties: {
      interactionSource: 'actions-dropdown'
    }
  });
  const handleDropdownOpenChange = useFetchDashboardOnOpen({
    dashboards,
    dashboardId: currentDashboardId
  });
  return !dashboard ? null : /*#__PURE__*/_jsx("div", {
    "data-onboarding": "dashboard-action-share",
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "secondary",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.action.share"
      }),
      buttonSize: "sm",
      closeOnMenuClick: true,
      "data-test-id": "dashboard-share-dropdown",
      placement: "bottom left",
      onOpenChange: handleDropdownOpenChange,
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [renderCopyUrl(), renderShareToSlackButton(), renderSendEmail(), renderManageEmail()]
      })
    }, "share-actions")
  });
};
export default compose(withDialog, withDashboardPermission, connectFlux({
  dashboards: DashboardsDependency
}), withUserInfo)(ShareActionsDropdown);